import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Tooltip,
  ButtonGroup,
} from '@mui/material'
import { useGetList } from 'react-admin'
import React, { useState } from 'react'
import { getLeadAssignmentReportRequest } from '../../Utils/RestUtils'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import InputAdornment from '@mui/material/InputAdornment'
import { ModeEdit } from '@mui/icons-material'

const ListLeadAssignment = (props) => {
  const [reportResponse, setReportResponse] = useState(null)
  const [isLoadingReport, setIsLoadingReport] = useState(false)

  const getInitialDates = () => {
    const today = new Date()
    const fromDate = new Date(
      Date.UTC(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0,
        0
      )
    )

    const toDate = new Date(
      Date.UTC(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        23,
        59,
        59,
        999
      )
    )
    return {
      from: fromDate.toISOString(),
      to: toDate.toISOString(),
    }
  }

  const [filters, setFilters] = useState({
    ...getInitialDates(),
    mainUser: 1,
  })

  const { data: usersCollection, isLoading } = useGetList('users', {
    pagination: { page: 1, perPage: 1000 },
    sort: { field: 'id', order: 'ASC' },
    filter: { disabled: 0 },
  })

  const handleFilterChange = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.value })
  }

  const getLeadAssignment = async () => {
    setIsLoadingReport(true)
    const apiFilters = { ...filters }

    if (filters.mainUser === 'all') {
      delete apiFilters.mainUser
    }

    const response = await getLeadAssignmentReportRequest(apiFilters)
    setReportResponse(response.data)
    setIsLoadingReport(false)
  }

  return (
    <CardContent>
      <Typography typography="h4" component="h1" mb={2}>
        Lead Assignment
      </Typography>
      <Box
        sx={{
          display: 'flex',
          marginTop: '10px',
          marginBottom: '10px',
          gap: '1rem',
        }}
      >
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              inputFormat="DD/MM/YYYY"
              label="From"
              value={dayjs(filters.from)}
              onChange={(selectedDate) => {
                const date = selectedDate.toDate()
                const utcDate = new Date(
                  Date.UTC(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate(),
                    0,
                    0,
                    0,
                    0
                  )
                )
                setFilters({
                  ...filters,
                  from: utcDate.toISOString(),
                })
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              inputFormat="DD/MM/YYYY"
              maxDate={
                new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
              }
              label="To"
              value={dayjs(filters.to)}
              onChange={(selectedDate) => {
                const date = selectedDate.toDate()
                const utcDate = new Date(
                  Date.UTC(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate(),
                    23,
                    59,
                    59,
                    999
                  )
                )
                setFilters({
                  ...filters,
                  to: utcDate.toISOString(),
                })
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>
        <Box>
          <FormControl sx={{ minWidth: 200 }} size="small">
            <InputLabel id="main-user-label">Main User</InputLabel>
            <Select
              name="mainUser"
              labelId="main-user-label"
              value={filters.mainUser}
              label="Main User"
              onChange={handleFilterChange}
              disabled={isLoading}
              endAdornment={
                isLoading && (
                  <InputAdornment position="end">
                    <CircularProgress size={20} />
                  </InputAdornment>
                )
              }
            >
              <MenuItem value="all">All Users</MenuItem>
              {usersCollection?.map((user) => (
                <MenuItem key={user.id} value={user.originId}>
                  {user.displayName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box>
          <Button
            disabled={isLoading}
            onClick={() => {
              getLeadAssignment()
            }}
          >
            Search
          </Button>
        </Box>
      </Box>
      <Card style={{ padding: '20px' }}>
        {isLoadingReport ? (
          <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
        ) : (
          reportResponse !== null &&
          reportResponse.length !== 0 && (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '15%' }}>Lead Id</TableCell>
                  <TableCell>Postcode</TableCell>
                  <TableCell>Registration</TableCell>
                  <TableCell>Make</TableCell>
                  <TableCell>Model</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Main User</TableCell>
                  <TableCell>Cancellation rate</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportResponse?.map((lead) => (
                  <TableRow key={lead.id}>
                    <TableCell>{lead.id}</TableCell>
                    <TableCell>{lead.leadContact.postcode}</TableCell>
                    <TableCell>
                      {lead.leadContact.vehicle.registration}
                    </TableCell>
                    <TableCell>{lead.leadContact.vehicle.make}</TableCell>
                    <TableCell>{lead.leadContact.vehicle.model}</TableCell>
                    <TableCell>{lead.status}</TableCell>
                    <TableCell>{lead.mainUser?.displayName}</TableCell>
                    <TableCell>
                      <ButtonGroup
                        sx={{
                          display: 'flex',
                          gap: 1,
                          justifyContent: 'flex-end',
                        }}
                      >
                        <React.Fragment>
                          <Tooltip title="Edit lead" position="right">
                            <Button
                              href={
                                '/#/quote-requests/' +
                                encodeURIComponent(
                                  '/api/quote-requests/' + lead.id
                                )
                              }
                              label="Edit lead"
                              className="quote-list__table-body_edit-btn"
                              style={{
                                fontSize: '0.6rem',
                              }}
                            >
                              <ModeEdit />
                            </Button>
                          </Tooltip>
                        </React.Fragment>
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )
        )}
        {reportResponse && reportResponse.length === 0 ? (
          <Alert icon={false} severity="error">
            No results found.
          </Alert>
        ) : null}
        {reportResponse === null && (
          <Alert icon={false} severity="info">
            Search for results
          </Alert>
        )}
      </Card>
    </CardContent>
  )
}

export default ListLeadAssignment
